export class Tag {
    name: string = "";
    value: string = "";

    parse(obj: any) {
        this.name = obj.Name;
        this.value = obj.Value;
    }
}

export class TagValues {
    tagName: string;
    availableValues: string[] = [];

    public parse(obj: any) {
        if (obj.TagName) this.tagName = obj.TagName;

        this.availableValues = [];
        if (obj.AvailableValues != null && obj.AvailableValues.length > 0)
            obj.AvailableValues.forEach((v) => {
                this.availableValues.push(v);
            });
    }
}
